import { chooseMFromNShuffle, random } from "seneca-common/utils/functions";

import { MultipleChoiceContent, MultipleChoiceContentSource } from "../types";

const MAX_WRONG_ANSWERS = 4;

export function generateMultipleChoiceContent(
  source: MultipleChoiceContentSource
): MultipleChoiceContent {
  const { question, wrongAnswers, correctAnswer, image } = source;
  const wrongAnswersLength = Math.min(MAX_WRONG_ANSWERS, wrongAnswers.length);
  const wrongAnswerIndexes = chooseMFromNShuffle(
    wrongAnswersLength,
    wrongAnswers.length
  );
  const correctAnswerIndex = random(0, wrongAnswersLength);

  let answers = wrongAnswerIndexes.map(index => wrongAnswers[index]);
  answers = [
    ...answers.slice(0, correctAnswerIndex),
    correctAnswer,
    ...answers.slice(correctAnswerIndex)
  ];

  return {
    question,
    answers,
    correctAnswerIndex,
    image
  };
}
